<p-drawer
    [id]="'app-sidebar'"
    [position]="'left'"
    [visible]="true"
    [showCloseIcon]="false"
    [styleClass]="isCollapsed() ? 'app-sidebar collapsed' : 'app-sidebar expanded'"
    [modal]="false">
    <div id="sidebar-header">
        <a [routerLink]="appRoutes.DASHBOARD" aria-label="Go to Dashboard">
            <span style="position: relative; width: 40px; height: 40px; display: block">
                <img
                    [ngSrc]="'assets/images/app-logo.svg'"
                    fill
                    id="app-logo-sidebar"
                    alt="The application logo and redirects to the dashboard" />
            </span>
        </a>
        <div>
            <p id="app-title">QuickOrder</p>
            <p id="app-subtitle">Transnetyx</p>
        </div>
    </div>

    <div id="sidebar-content">
        <app-navigation [isSidebarCollapsed]="isCollapsed()" (toggleIsCollapsed)="toggleIsCollapsed()"></app-navigation>
    </div>

    <div
        [id]="'collapse-area'"
        (click)="toggleIsCollapsed()"
        [ngClass]="isCollapsed() ? 'collapse-area-c' : 'collapse-area-e'">
        <ui-button-icon
            [id]="'collapse-sidebar'"
            [icon]="''"
            [ariaLabel]="isCollapsed() ? 'Expand Sidebar' : 'Collapse Sidebar'">
            <i
                [class]="'fa-thin fa-angle-right'"
                [class.collapsed]="isCollapsed()"
                [class.expanded]="!isCollapsed()"></i>
        </ui-button-icon>
    </div>
</p-drawer>
